import { Seal, Signature, UnsavedSeal } from '@paragon/contract-library';
import { sealingService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import {
  createSeal as createSealAction,
  createSignatures as createSignaturesAction,
  removeSeal as removeSealAction,
  removeSignature as removeSignatureAction,
  updateSeal as updateSealAction,
} from '../store/sealsAndSignaturesSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export const removeSeal =
  (sealId: number): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Removing seal...'));

    try {
      await sealingService.seals.remove(sealId);
      dispatch(removeSealAction(sealId));
    } catch (e) {
      console.log(e);
      dispatch(enqueueError('Error removing seal'));
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };

export const updateSeal =
  (sealWithUpdates: Seal): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Updating seal...'));

    try {
      const updatedSeal = await sealingService.seals.update(sealWithUpdates);
      dispatch(updateSealAction(updatedSeal));
    } catch (e) {
      console.log(e);
      dispatch(enqueueError('Error updating seal'));
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };

export const createSeal =
  (seal: UnsavedSeal): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Creating seal...'));

    try {
      const createdSeal = await sealingService.seals.create(seal);
      dispatch(createSealAction(createdSeal));
    } catch (e) {
      console.log(e);
      dispatch(enqueueError('Error creating seal'));
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };

export const createSignatures =
  (signatureImages: readonly { readonly contents: string }[]): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    const spinnerId = dispatch(addSpinnerMessage('Creating signatures...'));

    try {
      const results = await Promise.all(
        signatureImages.map((signatureImage) => {
          const signature = {
            userEmail: state.userData.users[state.userData.userToEdit!].email,
            image: signatureImage.contents,
          };
          return sealingService.signatures.create(signature);
        }),
      );
      dispatch(createSignaturesAction(results));
    } catch (e) {
      console.log(e);
      dispatch(enqueueError('Error creating signature'));
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };

export const removeSignature =
  (signature: Signature): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Removing signature...'));
    try {
      await sealingService.signatures.remove(signature.id);
      dispatch(removeSignatureAction(signature.id));
    } catch (e) {
      console.log(e);
      dispatch(enqueueError('Error removing signature'));
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };
